/*
  The pace chart's colours. Highcharts is configured in JavaScript and cannot use a stylesheet variable, so instead of
  repeating hex codes here they are read from the --chart-* custom properties that _funnelfuel-dashboard.scss derives
  from the project's variables (abstracts/_variables.scss). One definition, in the stylesheet.

  `element` must be inside .ff-dash. A property that is not defined comes back undefined, and Highcharts then uses its
  own default for it.
*/
const CHART_COLOR_NAMES = ["target", "all", "selection", "axis", "grid", "label", "legend", "marker"];

export const readChartColors = (element) => {
  const style = element ? window.getComputedStyle(element) : null;

  return CHART_COLOR_NAMES.reduce((colors, name) => {
    colors[name] = (style && style.getPropertyValue(`--chart-${name}`).trim()) || undefined;
    return colors;
  }, {});
};
